import { Link } from "react-router-dom";
import { Phone, EnvelopeSimple, MapPin, FacebookLogo, InstagramLogo, LinkedinLogo, Star } from "@phosphor-icons/react";
import { NAV, BUSINESS } from "../../lib/data";

export const Footer = () => {
  const socials = [
    { icon: FacebookLogo, href: BUSINESS.socials.facebook, label: "Facebook" },
    { icon: InstagramLogo, href: BUSINESS.socials.instagram, label: "Instagram" },
    { icon: LinkedinLogo, href: BUSINESS.socials.linkedin, label: "LinkedIn" },
    { icon: Star, href: BUSINESS.socials.yelp, label: "Yelp" },
  ];
  return (
    <footer data-testid="site-footer" className="bg-navy-900 text-white relative overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 pt-20 pb-10">
        <div className="grid lg:grid-cols-[1.4fr_1fr_1fr] gap-12">
          <div>
            <span className="inline-grid w-24 h-24 rounded-full bg-white shadow-sm place-items-center overflow-hidden mb-6">
              <img src={BUSINESS.logo} alt="A Man With A Plan Handyman Services logo" className="w-full h-full object-contain p-1" />
            </span>
            <span className="block text-xs font-bold uppercase tracking-[0.2em] text-navy-400">
              {BUSINESS.location}
            </span>
            <h3 className="font-display font-black text-4xl md:text-5xl tracking-tight mt-3 leading-[1.1]">
              A Man With <br /> A Plan.
            </h3>
            <p className="text-slate-400 mt-5 max-w-sm">
              Professional handyman services across {BUSINESS.area}. Reliable, honest work that gives you
              peace of mind.
            </p>
            <div className="flex gap-3 mt-6">
              {socials.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noreferrer"
                  data-testid={`footer-social-${s.label.toLowerCase()}`}
                  aria-label={s.label}
                  className="w-11 h-11 grid place-items-center rounded-full border border-white/15 hover:bg-white hover:text-navy-900 transition-colors"
                >
                  <s.icon size={20} weight="fill" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold uppercase tracking-[0.18em] text-navy-400 mb-5">Explore</h4>
            <ul className="space-y-3">
              {NAV.map((n) => (
                <li key={n.to}>
                  <Link
                    to={n.to}
                    className="text-slate-300 hover:text-white transition-colors font-medium"
                  >
                    {n.label}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/careers"
                  data-testid="footer-careers-link"
                  className="text-slate-300 hover:text-white transition-colors font-medium"
                >
                  Careers
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold uppercase tracking-[0.18em] text-navy-400 mb-5">Get in touch</h4>
            <ul className="space-y-4">
              <li>
                <a href={BUSINESS.phoneHref} className="flex items-center gap-3 text-slate-200 hover:text-white">
                  <Phone size={20} weight="fill" /> {BUSINESS.phone}
                </a>
              </li>
              <li>
                <a href={`mailto:${BUSINESS.email}`} className="flex items-center gap-3 text-slate-200 hover:text-white break-all">
                  <EnvelopeSimple size={20} weight="fill" /> {BUSINESS.email}
                </a>
              </li>
              <li className="flex items-center gap-3 text-slate-200">
                <MapPin size={20} weight="fill" /> {BUSINESS.location}
              </li>
            </ul>
            <Link
              to="/contact-us"
              data-testid="footer-quote-btn"
              className="inline-flex mt-6 rounded-full bg-white text-navy-900 px-6 py-3 font-bold hover:bg-slate-200 transition-colors"
            >
              Request a Quote
            </Link>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-3 text-sm text-slate-400">
          <p>© {new Date().getFullYear()} {BUSINESS.legal}. All rights reserved.</p>
          <p>Charleston, SC · Licensed & Insured</p>
        </div>
      </div>
    </footer>
  );
};
